// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M743","container":"styles_container__2EORf","footer":"styles_footer__2Udmy"};